const updateServices = {
  toastr: 'Serviço atualizado com sucesso',
  toastrError: 'Serviço já cadastrado',
  toastrError1: 'Nome já cadastrado'
};

export default updateServices;
